import { createContext } from "react";


export const PopUpVisabilityContext = createContext({
    visability: '',
    HideOrShow: () => { }
})